import React from "react";
import { Formik, Form, Field } from "formik";
import { useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import { addNewMessageThunk } from "../../modules/ticket/ticketForm/ticketFormOperations";
import { FileInput } from "./FileInput";
import { fetchMessagesByTicketIdThunk } from "../../modules/ticket/ticketDetail/messages/messageListOperations";
import sanitizeHtml from "sanitize-html";

import {
  Divider,
  TextField,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
} from "@mui/material";

import {
  Send as SendIcon,
  RemoveCircleOutline as DeleteIcon,
  InsertDriveFile as FileIcon,
} from "@mui/icons-material";

/**
 *
 * @param {*} theme
 */
const useStyles = makeStyles((theme) => ({
  chatForm: {
    display: "flex",
    alignItems: "center",
  },

  textInput: {
    flexGrow: 1,
  },

  divider: {
    width: 1,
    height: 28,
    margin: 4,
  },
}));

const sanitizeConf = {
  allowedTags: ["b", "br", "i", "em", "strong", "a", "p", "h1"],
  allowedAttributes: { a: ["href"] },
};

// Our inner form component which receives our form's state and updater methods as props
const TicketsChatForm = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { itemId } = props;

  const initialValues = {
    content: "",
    files: [],
  };

  const handleSubmit = (values, { setSubmitting, setErrors, resetForm }) => {
    // Set form to submitting
    setSubmitting(true);

    const tempContent = values.content.split("\n").join("<br>");
    values.content = sanitizeHtml(tempContent, sanitizeConf);

    const message = {
      id: itemId,
      content: values.content,
      attachments: values.files,
    };

    dispatch(addNewMessageThunk(message))
      .then(() => {
        // reload message list
        dispatch(fetchMessagesByTicketIdThunk(itemId));
        resetForm();
        setSubmitting(false);
      })
      .catch((err) => {
        setSubmitting(false);
        setErrors(err.message);
      });
  };

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit}>
      {({ values, handleChange, isSubmitting, setValues }) => {
        const handleFileInputChange = (fileList) => {
          // manually set the list of attachments for formik
          setValues({ ...values, files: fileList });
        };

        const handleFileRemove = (id) => {
          const sanitizedFiles = values.files.filter(
            (file) => !(id === file.id),
          );
          // manually set the list of attachments for formik
          setValues({ ...values, files: sanitizedFiles });
        };

        const hasFiles = values.files && values.files.length > 0;

        return (
          <div>
            {hasFiles && (
              <List dense={true}>
                {values.files.map((file) => (
                  <ListItem key={file.id}>
                    <ListItemIcon>
                      <FileIcon />
                    </ListItemIcon>
                    <ListItemText>{file.name}</ListItemText>
                    <ListItemSecondaryAction>
                      <IconButton onClick={() => handleFileRemove(file.id)}>
                        <DeleteIcon />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                ))}
              </List>
            )}

            <Form className={classes.chatForm}>
              <Field name="content">
                {({ field }) => (
                  <TextField
                    {...field}
                    disabled={isSubmitting}
                    placeholder="Mitteilung schreiben ..."
                    multiline
                    className={classes.textInput}
                  />
                )}
              </Field>

              <FileInput color="primary" onChange={handleFileInputChange} />

              <Divider className={classes.divider} />
              <IconButton
                color="primary"
                aria-label="Send"
                type="submit"
                disabled={isSubmitting}
              >
                <SendIcon />
              </IconButton>
            </Form>
          </div>
        );
      }}
    </Formik>
  );
};

export default TicketsChatForm;
